import { TrackingIconSlot } from '../models';
import { useGetCurrentTrackingIconsQuery } from '../services';

const useCurrentTrackingIcon = (slot: TrackingIconSlot) => {
  const { currentData, isLoading, isFetching, error, refetch } =
    useGetCurrentTrackingIconsQuery(undefined, {
      pollingInterval: 30000,
      refetchOnMountOrArgChange: true,
    });

  return {
    currentIcon: currentData?.find((icon) => icon.slot === slot),
    isLoading,
    isFetching,
    error,
    refetch,
  };
};

export default useCurrentTrackingIcon;
